export default __webpack_public_path__ + "static/media/Fill-in-the-Blank.ab1858bb.gif";